import useSWR from 'swr';
import AxiosConfig from '../../../config/AxiosConfig';
import { setSnackBar } from '../../states/app/staticSlice';
import { useDispatch } from 'react-redux';

const fetcher = async (url, formData) =>
  await AxiosConfig.create('put', url).call(formData).getResponseData();

function useTemplate(formData) {
  const dispatch = useDispatch();
  const { data, error, isLoading, isValidating, mutate } = useSWR(
    '/templates',
    (url) => fetcher(url, formData),
    {
      refreshInterval: 0,
      revalidateOnFocus: true,
    }
  );

  if (error?.res?.status > 300) {
    const messageError = `Error ${error?.res?.status} - ${error?.res?.statusText} in useTemplateUpdate`;
    dispatch(
      setSnackBar({ open: true, message: messageError, color: 'error' })
    );
  }

  return {
    templateList: data,
    isLoading: isLoading,
    isValidating: isValidating,
    mutate: mutate,
  };
}

export default useTemplate;
